import PropTypes from 'prop-types';
import React, {useEffect, useRef, useState} from 'react';
import Floater from 'react-floater';
import assetUrl from '../../../utils/assetUrl';

const imgDir = assetUrl('images');


const CvvHint = ({translations}) => {
    const popupRef = useRef();
    const popupButtonRef = useRef();
    const [showPopup, setShowPopup] = useState(false);

    const togglePopup = () => {
        setShowPopup(current => !current);
    };

    const hidePopup = () => {
        setShowPopup(false);
    };

    const closePopupOnOutsideClick = event => {
        const popupClick = popupRef?.current.contains(event.target);
        const popupButtonClick = popupButtonRef?.current.contains(event.target);
        if (!popupClick && !popupButtonClick) {
            hidePopup();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', closePopupOnOutsideClick);

        return () => {
            document.removeEventListener('mousedown', closePopupOnOutsideClick);
        };
    }, []);


    return (
        <div>
            <button
                type="button"
                ref={popupButtonRef}
                onClick={togglePopup}
                tabIndex="-1"
                className="popup-target-button"
            >
                <img
                    className="cvv-icon"
                    src={`${imgDir}/cvc.svg`}
                    alt="back side of card"
                />
            </button>
            <Floater
                autoOpen={false}
                placement="bottom-end"
                open={showPopup}
                target=".popup-target-button"
                styles={{
                    container: {
                        padding: '1.2rem 1rem 1rem 1rem',
                        minWidth: '19rem',
                        minHeight: '10.25rem'
                    },
                    arrow: {
                        length: 14,
                        spread: 24,
                        margin: 10
                    }
                }}
                content={(
                    <div className="floater" ref={popupRef}>
                        <button
                            className="popup-close-btn"
                            type="button"
                            onClick={hidePopup}
                            style={{backgroundImage: `url(${imgDir}/close.svg)`}}
                        />
                        <h2 className="help-popup-title">{translations.titleThreeDigits}</h2>
                        <div className="help-popup-content">
                            <img
                                className="cvv-icon-popup"
                                src={`${imgDir}/cvc-large.png`}
                                srcSet={`${imgDir}/cvc-large@2x.png 2x, ${imgDir}/cvc-large@3x.png 3x`}
                                alt="back side of card"
                            />
                            <span className="help-popup-side-text">
                                {translations.text}
                            </span>
                        </div>
                    </div>
                )}
            />
        </div>
    );
};

CvvHint.propTypes = {
    translations: PropTypes.shape({
        titleThreeDigits: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired
    }).isRequired
};

export default CvvHint;
